// Header
import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Stack,
    Snackbar,
    Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { Menus } from '../menus';
import { VersionChecker } from './versionChecker';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backgroundColor: theme.palette.figma.mainBg,
    '&::before': {
        display: 'none !important',
    },
}));

const StyledToolbar = styled(Toolbar)(({ theme, apptype }) => ({
    paddingRight: '24px',
    minHeight: apptype === 'user' ? '40px !important' : '64px !important',
    backgroundColor: apptype === 'user' ? theme.palette.figma.mainBg : theme.palette.figma.block,
    justifyContent: apptype === 'user' ? 'center' : 'flex-start',
}));

export const Header = ({
    appType,
    setMenusWidth,
    setPageWidth,
    isMenuOpen,
    setIsMenuOpen,
}) => {

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    return (
        <>
            <VersionChecker />

            <StyledAppBar
                position="sticky"
                sx={{
                    '&::before': {
                        display: 'none !important',
                    },
                    zIndex: 0,
                }}
            >
                <StyledToolbar apptype={appType} >
                    <Stack
                        direction="row"
                        width="100%"
                        alignItems="center"
                    >
                        <Menus
                            appType={appType}
                            setMenusWidth={setMenusWidth}
                            setPageWidth={setPageWidth}
                            open={isMenuOpen}
                            onClose={() => setIsMenuOpen(false)}
                        />
                    </Stack>
                </StyledToolbar>
            </StyledAppBar >
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%', borderRadius: '8px' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};
